import moment from 'moment';
import utils from '@/plugins/TravellerUtils';

const statistics = {
    namespaced: true,
    state: {
        currentlyDrivenDepartureStatistics: []
    },
    mutations: {
        updateCurrentlyDrivenDepartureStatistics(state, departureStatistics) {
            state.currentlyDrivenDepartureStatistics = departureStatistics;
        }
    },
    actions: {
        getCurrentlyDrivenDepartureStatistics(context) {
            return new Promise((resolve, reject) => {
              const currentDate = moment().format("YYYY-MM-DD");
              const currentTime = moment().format("HH:mm:ss");
              this._vm.$traveller_http.get('/traveller/restui/system/getCurrentlyDrivenDepartureStatistics', { params: { "currentDate": currentDate, "currentTime": currentTime } })
                .then(response => {
                    if(utils.checkResponseIsObject(response)) {
                        context.commit('updateCurrentlyDrivenDepartureStatistics', response.data);
                        resolve(response.data);
                    } else {
                        reject("Response is not a object.");
                    }
                }),
                error => {
                    reject(error);
                }
            });
        }
    }
  }
  
  export default statistics;